import { ArrowUp } from 'lucide-react';

import {
    useChatData,
    useChatInteract,
    useChatMessages
} from '@chainlit/react-client';

import { Stop } from '@/components/icons/Stop';
import { Button } from '@/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger
} from '@/components/ui/tooltip';
import { Translator } from 'components/i18n';

interface SubmitBtnProps {
    disabled?: boolean;
    onSubmit?: () => void;
    onFocus?: () => void;
}

export const SubmitBtn = ({ disabled, onSubmit, onFocus }: SubmitBtnProps) => {
    const { loading } = useChatData();
    const { firstInteraction } = useChatMessages();
    const { stopTask } = useChatInteract();

    const handleSubmit = () => {
        onSubmit?.();
        setTimeout(() => {
            onFocus?.();
        }, 100);
    };

    const handleStop = () => {
        stopTask();
        setTimeout(() => {
            onFocus?.();
        }, 100);
    };

    return (
        <div id="submit-button">
            {loading && firstInteraction ? (
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button pill
                            id="stop-button"
                            onClick={handleStop}
                            size="icon"
                           
                        >
                            <Stop />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>
                            <Translator path="chat.input.actions.stop" />
                        </p>
                    </TooltipContent>
                </Tooltip>
            ) : (
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            variant={'primary'}
                            size={'icon'}
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            <ArrowUp />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>
                            <Translator path="chat.input.actions.send" />
                        </p>
                    </TooltipContent>
                </Tooltip>
            )}
        </div>
    );
};
